import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

function mapStateToProps(state){
  //TODO: Connect Redux state to AgencyManageAccount
  return state;
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AgencyManageAccount
  return bindActionCreators({},dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccount/connect.js